import { useQuery } from '@tanstack/react-query';

import { fetchQuestsKratesMetadata } from '#/api/apiQuests';
import { minutes } from '#/api/queries/utils';

// TODO: krates USD prize hardcoded (not present in the metadata API)
const QUEST_PRIZE_POOL_USD = 10700;

/**
 * Krates (XP quests) metadata - price in XP, supply, reward tiers.
 * Values change roughly monthly, no need for aggressive refetching.
 * No fallback data - while loading and whenever the API call fails
 * (unreachable/down API, unexpected response structure, or CORS not allowing
 * perps origins) `data` stays undefined and consumers hide the values.
 */
export function useQuestsKratesMetadata() {
  return useQuery({
    queryKey: ['questsKrates', 'metadata'],
    queryFn: async () => {
      const metadata = await fetchQuestsKratesMetadata();
      return {
        priceXp: metadata.priceXp,
        prizePoolUsd: QUEST_PRIZE_POOL_USD,
      };
    },
    staleTime: minutes(60),
    // Keep retries low - when the API is unreachable there is no point
    // hammering it, consumers render without the values.
    retry: 1,
  });
}
